import { takeLatest, put, call, putResolve } from 'redux-saga/effects';
import find from 'lodash/find';
import toLower from 'lodash/toLower';
import axios from 'axios';
import {
  beginLoadingDesign,
  endLoadingDesign,
  getDesignByItem,
  setDesignDetails,
  GET_DESIGN_BY_ITEM_FAILED,
  loadConfiguratorOptions
} from '../actions';
import safeSaga from './safeSaga';

const flooringBaseUrl = typeof window !== 'undefined' && window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
function fetchDesignData(itemId) {
  const url = `${flooringBaseUrl}/designs/item/${itemId}?time=${new Date().toISOString()}`;
  return axios.get(url);
}

function* getDesignByItemId({ payload: { itemId, isFromSaveLogin = false } }) {
  yield put(beginLoadingDesign());
  try {
    const { data, status } = yield call(fetchDesignData, itemId);
    if (data) {
      const { designInfo: { design, items } = {} } = data;
      const currentItem = (items && items.find((i) => toLower(i.itemId) === toLower(itemId))) || {};
      const designDetails = {
        currentDesign: design,
        currentItem,
        status, // status is undefined always
        configurationSaved: true,
        designAssociated: !isFromSaveLogin,
        emailSent: !isFromSaveLogin,
      };
      yield putResolve(setDesignDetails(designDetails));

      const { choices: savedDesignChoices } = currentItem.itemProduct;
      const storeIdChoice = find(savedDesignChoices, (ch) => ch.optionName === 'Store Id');
      yield putResolve(loadConfiguratorOptions(storeIdChoice.choiceValue));
    }
    yield put(endLoadingDesign());
  } catch (err) {
    yield put({
      type: GET_DESIGN_BY_ITEM_FAILED,
      payload: err.response && err.response.data,
    });
  }
}

export function* getDesignByItemSaga() {
  yield takeLatest(getDesignByItem.toString(), safeSaga(getDesignByItemId));
}
